import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { BREAK_POINTS } from '../../../../constants/common/breakpoints';

const StyledSidebarContainer = styled.div<React.ComponentPropsWithRef<'div'>>`
    border-radius: 6px;
    padding-top:45px;
    display: flex;
    flex-direction: column;
    border: none;
    .gi-sidebar_nav_list {
        background: ${({ theme }) => theme.defaultWhite};
        font-weight: 400;
    }
    @media (max-width: ${BREAK_POINTS.sm}) {
        width: 100%;
    }
    .theme-bg {
        padding:10px;
        background-color: ${({ theme }) => theme.infoLightest} !important;
    }
`;

const SidebarTop = () => {
    return (
        <StyledSidebarContainer className='referral-linking-side-nav' data-testid="dynamic-security-side-nav-conatainer">
            <h1 className="pull-left" data-testid="referral-linking-header">
                <FormattedMessage id='dynamicSecurityQuestion.referralLinking'/>
            </h1>
        </StyledSidebarContainer>
    );
};

export default SidebarTop;
